import * as yup from 'yup';

const adminSchema = yup.object().shape({
  email: yup
    .string()
    .email('E-mail inválido'),
    // .transform(value => value?.trim() || ''),
  username: yup
    .string()
    //.transform(value => value?.trim() || '')
})
.test(
  'both-or-none',
  'Preencha ambos os campos ou deixe ambos vazios',
  function(value) {
    const { email, username } = value || {};
    const hasEmail = email && email.trim().length > 0;
    const hasUsername = username && username.trim().length > 0;
    
    // Permite ambos vazios ou ambos preenchidos
    return (!hasEmail && !hasUsername) || (hasEmail && hasUsername);
  }
);

const companySchema = yup.object().shape({
  name: yup
    .string()
    .required('Campo obrigatório')
    .transform(value => String(value || '').trim()),
  fantasyname: yup
    .string()
    .required('Campo obrigatório')
    .transform(value => String(value || '').trim()),
  cnpj: yup
    .string()
    .required('Campo obrigatório')
    .transform(value => String(value || '').replace(/[^\d]/g, '')),
  phone: yup
    .string()
    .required('Campo obrigatório')
    .transform(value => String(value || '').trim()),
  address: yup
    .string()
    .required('Campo obrigatório')
    .transform(value => String(value || '').trim()),
  cnae_list: yup
    .mixed()
    .transform(value => {
      if (Array.isArray(value) && value.length === 0) return '';
      if (typeof value === 'string') return value.trim();
      return String(value || '').trim();
    }),
  admin: adminSchema,
  newField: yup.boolean().optional(),
  previousAdmin: yup.boolean().optional(),
  id_company: yup.number().optional(),
  parent_company: yup.number().optional()
});

export const companieGroupSchema = yup.object().shape({
  form: yup
    .array()
    .of(companySchema)
    .required('Deve ter pelo menos uma empresa')
    .min(1, 'Mínimo de 1 empresa')
});

export const CNPJ_VALIDATION = yup
  .string()
  .matches(/^\d{14}$/, 'CNPJ inválido')
  .required('CNPJ é obrigatório');

export const EMAIL_VALIDATION = yup
  .string()
  .email('E-mail inválido')
  .required('E-mail é obrigatório');

export const validateCNPJ = (cnpj) => {
  try {
    return CNPJ_VALIDATION.validateSync(cnpj.replace(/[^\d]/g, ''));
  } catch (error) {
    return error.message;
  }
};

export const validateEmail = (email) => {
  try {
    return EMAIL_VALIDATION.validateSync(email);
  } catch (error) {
    return error.message;
  }
};